<script>
export default {
    name: "Loader.vue"
}
</script>

<template>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M11 2v4c0 .552.447 1 1 1 .552 0 1-.448 1-1V2c0-.553-.448-1-1-1 -.553 0-1 .447-1 1Z"/>
            <path d="M11 18v4c0 .552.447 1 1 1 .552 0 1-.448 1-1v-4c0-.553-.448-1-1-1 -.553 0-1 .447-1 1Z"/>
            <path d="M4.222 5.637l2.83 2.83c.39.39 1.023.39 1.414 0 .39-.391.39-1.024 0-1.415l-2.83-2.83c-.391-.391-1.024-.391-1.415 0 -.391.39-.391 1.023 0 1.414Z"/>
            <path d="M15.532 16.947l2.83 2.83c.39.39 1.023.39 1.414 0 .39-.391.39-1.024 0-1.415l-2.83-2.83c-.391-.391-1.024-.391-1.415 0 -.391.39-.391 1.023 0 1.414Z"/>
            <path d="M2 13h4c.552 0 1-.448 1-1 0-.553-.448-1-1-1H2c-.553 0-1 .447-1 1 0 .552.447 1 1 1Z"/>
            <path d="M18 13h4c.552 0 1-.448 1-1 0-.553-.448-1-1-1h-4c-.553 0-1 .447-1 1 0 .552.447 1 1 1Z"/>
            <path d="M5.637 19.777l2.83-2.83c.39-.391.39-1.024 0-1.415 -.391-.391-1.024-.391-1.415 0l-2.83 2.83c-.391.39-.391 1.023 0 1.414 .39.39 1.023.39 1.414 0Z"/>
            <path d="M16.947 8.467l2.83-2.83c.39-.391.39-1.024 0-1.415 -.391-.391-1.024-.391-1.415 0l-2.83 2.83c-.391.39-.391 1.023 0 1.414 .39.39 1.023.39 1.414 0Z"/>
        </g>
    </svg>
</template>

<style scoped>

</style>